import type { PlaylistItem } from '@/shared/models/playlist.model';

/**
 * Comparador do Repertório: mais pedida primeiro (`pedidos_count` desc),
 * empate resolvido pela ordem original da playlist (`ordem` asc).
 * Usado tanto no fetch inicial (RPC já devolve nessa ordem) quanto ao
 * reordenar in-memory após INSERT via Realtime em `usePlaylistItens`.
 */
export function compararPorMaisPedida(a: PlaylistItem, b: PlaylistItem): number {
  const diff = (b.pedidos_count ?? 0) - (a.pedidos_count ?? 0);
  return diff !== 0 ? diff : a.ordem - b.ordem;
}
